import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCommentLike } from "./../_redux/commentSlice";
import { timeFormatter, socialShare, htmlToText } from "./../helpers";
import { useTranslation } from "react-i18next";
import { setHeightLayout } from "./../helpers";
import HTMLEllipsis from "react-lines-ellipsis/lib/html";
import TippyAction from "./TippyAction";

function CommentItem({
    data,
    onToggleReply,
    isReply,
    lastIndexItem,
    currentIndex
}) {
    // __REDUX
    const { currentState } = useSelector(state => ({
        currentState: state.comment
    }));
    const { commentSetting } = currentState;
    // __STATE
    // const [isLike, setIsLike] = useState(false);
    // const [maxLimitLike, setMaxLimitLike] = useState(0);
    const [showMore, setShowMore] = useState(false);
    // console.log(lastIndexItem,currentIndex);
    // handle languages
    const { t } = useTranslation();
    // __FUNCTION HANDLE
    const onOpenAndCloseReply = () => {
        if (isReply) onToggleReply(false);
        else onToggleReply(true);
    };

    // effect handle active vote
    // useEffect(() => {
    //     if (
    //         localStorage.getItem(`vnn-active-vote-ID${commentSetting.objectId}`)
    //     ) {
    //         let isEmpty = true;
    //         JSON.parse(
    //             localStorage.getItem(
    //                 `vnn-active-vote-ID${commentSetting.objectId}`
    //             )
    //         ).forEach(item => {
    //             if (item?.commentId == data.commentId) isEmpty = false;
    //         });
    //         if (!isEmpty) setIsLike(true);
    //     }
    // }, []);
    // function handle active vote
    // const onHandleActiveVote = () => {
    //     let totalVoteActive = localStorage.getItem(
    //         `vnn-active-vote-ID${commentSetting.objectId}`
    //     )
    //         ? JSON.parse(
    //               localStorage.getItem(
    //                   `vnn-active-vote-ID${commentSetting.objectId}`
    //               )
    //           )
    //         : [];
    //     if (!isLike) {
    //         // console.log(data.commentId);
    //         // console.log(commentSetting.objectId);
    //         totalVoteActive.push({
    //             objectId: commentSetting.objectId,
    //             commentId: data.commentId
    //         });
    //         localStorage.setItem(
    //             `vnn-active-vote-ID${commentSetting.objectId}`,
    //             JSON.stringify(totalVoteActive)
    //         );
    //     } else {
    //         totalVoteActive = totalVoteActive.filter(
    //             item => item.commentId !== data.commentId
    //         );
    //         // console.log(totalVoteActive);
    //         if (totalVoteActive.length > 0) {
    //             localStorage.setItem(
    //                 `vnn-active-vote-ID${commentSetting.objectId}`,
    //                 JSON.stringify(totalVoteActive)
    //             );
    //         } else
    //             localStorage.removeItem(
    //                 `vnn-active-vote-ID${commentSetting.objectId}`
    //             );
    //     }
    // };

    const onHandleSeemoreContent = () => {
        setTimeout(() => setHeightLayout(20));
        setShowMore(true);
    };
    // console.log(commentSetting);
    // __RENDER
    return (
        <div className='user__item relative grid grid-cols-[35px,1fr] gap-[15px] mx-[10px] py-[8px] '>
            <div className=''>
                {data.avatarUrl ? (
                    <div
                        className='w-[32px] rounded-full h-[32px] bg-no-repeat bg-cover bg-center'
                        style={{
                            backgroundImage: `url(${data.avatarUrl})`
                        }}></div>
                ) : (
                    <div
                        className='w-[32px] text-[#999] leading-[32px] text-center bg-gray-200 text-[18px]
                    rounded-full h-[32px] bg-no-repeat uppercase bg-cover bg-center'>
                        {data.userName.split("")[0]}
                    </div>
                )}
            </div>
            <div className='author__dataBinding'>
                <div
                    style={{
                        color:
                            commentSetting?.version &&
                            commentSetting?.version === "2.0.0"
                                ? commentSetting.commentConfiguration
                                      .themeConfig.userBlock.titleColor
                                : commentSetting?.theme?.textColor
                    }}
                    className='text-[#2D67AD] mb-[5px] flex items-center text-[16px] font-arial font-semibold font-weight-none sm:font-notosans-bold '>
                    {data.userName}
                    {data?.isPin && (
                        <img
                            className='w-[17px] ml-[7px] '
                            src='https://static.vnncdn.net/v1/icon/pin.svg'
                            alt='pin'
                        /> 
                    )}
                </div>
                <div className='content__wrapper'>
                    <div 
                        style={{
                            color:
                                commentSetting?.version &&
                                commentSetting?.version === "2.0.0" &&
                                commentSetting.commentConfiguration.themeConfig
                                    .userBlock.contentColor
                        }}
                        className='__content text-[15px] break-words mb-[5px] text-black'>
                        {showMore ? (
                            <div
                                className='break-content'
                                dangerouslySetInnerHTML={{
                                    __html: data.commentContent.replace(
                                        /style="[^"]*"/,
                                        ""
                                    )
                                }}></div>
                        ) : (
                            <HTMLEllipsis
                                onClick={onHandleSeemoreContent}
                                maxLine='3'
                                unsafeHTML={data.commentContent.replace(
                                    /style="[^"]*"/,
                                    ""
                                )}
                                ellipsis={t('message.input.readmore')}
                                basedOn='letters'
                                className='content__Ellipsis break-words'
                            />
                        )}
                    </div>
                    <div className='__actions flex justify-between flex-wrap text-[14px] text-[#838383]'>
                        <div className='group-left flex items-center '>
                            <button
                                onClick={onOpenAndCloseReply}
                                className='hover:text-[#666] mr-[25px] '>
                                {t("message.actions.answer")}
                            </button>
                            {/* <span>.</span> */}
                            {/* <button
                                style={{
                                    color:
                                        isLike &&
                                        (commentSetting?.version &&
                                        commentSetting?.version === "2.0.0"
                                            ? commentSetting
                                                  .commentConfiguration
                                                  .themeConfig.userBlock.actions
                                                  .like.activeColor
                                            : commentSetting?.theme
                                                  ?.backgroundColor)
                                }}
                                onClick={onHandleLikeAndUnlike}
                                className={`group `}>
                                <span className='group-hover:text-[#666]'>
                                    Thích
                                </span>
                            </button> */}
                            <TippyAction data={data} />
                        </div>
                        {/* <span>.</span> */}
                        {/* <button className='group pl-[10px] relative pr-[10px] '>
                            <i className='fa group-hover:text-[#666] fa-share-alt text-[12px] mr-[5px] '></i>
                            <span className='group-hover:text-[#666]'>
                                {t("message.actions.share")}
                            </span>
                            <div
                                className={`share__dropdown ${
                                    lastIndexItem == currentIndex
                                        ? "top-[-40px]"
                                        : ""
                                } group-hover:flex gap-[10px] shadow-md z-[10] px-[10px] py-[10px] hidden absolute bg-white border`}>
                                <a
                                    onClick={e => {
                                        e.preventDefault();
                                        socialShare(
                                            "fb",
                                            data.userName,
                                            htmlToText(data.commentContent),
                                            commentSetting
                                        );
                                    }}
                                    className='block'
                                    href=''>
                                    <img
                                        className='min-w-[20px] h-[20px] rounded-sm '
                                        src='https://static.vnncdn.net/v1/icon/facebook_blue.svg'
                                        alt='facebook'
                                    />
                                </a>
                                <a
                                    onClick={e => {
                                        e.preventDefault();
                                        socialShare(
                                            "tw",
                                            data.userName,
                                            htmlToText(data.commentContent),
                                            commentSetting
                                        );
                                    }}
                                    className='block'
                                    href=''>
                                    <img
                                        className='min-w-[20px] h-[20px] !rounded-sm '
                                        src='https://static.vnncdn.net/v1/icon/twitter_blue.svg'
                                        alt='twitter'
                                    />
                                </a>
                            </div>
                        </button> */}
                        {/* <span>.</span> */}
                        <span className='text-[#838383] text-[14px]'>
                            {timeFormatter(data.createdDate)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CommentItem;
